import Markdown from '@/components/common/Markdown';
import { Text } from '@/components/common/Typography';
import { useMutation } from '@apollo/client';
import { Checkbox, Spacer } from '@chakra-ui/react';
import { assert } from '@common/errors';
import {
    AllFinancialEntitiesDocument,
    ConfirmAtomicIraDocument,
} from '@common/graphql/generated';
import { openAtomicIraAccount20240405 } from '@common/terms';
import { useState } from 'react';
import { labelByIraType } from './helpers';
import { useOpenIraFlowContext } from './OpenIraFlow';
import OpenIraFlowStep from './OpenIraFlowStep';

const OpenIraFlowTermsStep = () => {
    const { setStep, iraType, info, accountOnboardingId } =
        useOpenIraFlowContext();
    assert(info && accountOnboardingId);
    const [isAgreeChecked, setIsAgreeChecked] = useState(false);
    const [confirmAtomicIRA] = useMutation(ConfirmAtomicIraDocument, {
        refetchQueries: [AllFinancialEntitiesDocument],
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const terms = openAtomicIraAccount20240405;
    const nextButtonText = `Open my ${labelByIraType[iraType]} IRA`;

    return (
        <OpenIraFlowStep
            onBack={() => setStep('REVIEW')}
            onNext={async () => {
                setIsSubmitting(true);
                try {
                    await confirmAtomicIRA({
                        variables: {
                            accountOnboardingId,
                            consent: {
                                title: terms.title,
                                contents: terms.contents,
                                method: 'BUTTON',
                                buttonText: nextButtonText,
                            },
                        },
                    });
                    setStep('CELEBRATION');
                } finally {
                    setIsSubmitting(false);
                }
            }}
            isNextDisabled={!isAgreeChecked}
            nextButtonText={nextButtonText}
            isSubmitting={isSubmitting}
            footerMiddleContent={
                <>
                    <Spacer />
                    <Checkbox
                        isChecked={isAgreeChecked}
                        onChange={(e) => setIsAgreeChecked(e.target.checked)}
                        mr={12}
                    >
                        <Text ml={2} fontWeight="medium">
                            I agree to these terms
                        </Text>
                    </Checkbox>
                </>
            }
        >
            <Markdown content={terms.contents} />
        </OpenIraFlowStep>
    );
};

export default OpenIraFlowTermsStep;
